const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  loyaltyCurrentPoints: '[data-loyalty-current-points]',
  loyaltyCurrentLevel: '[data-loyalty-current-level]',
  loyaltyCurrentPerks: '[data-loyalty-current-perks]',
  loyaltyNextLevel: '[data-loyalty-next-level]',
  loyaltyNextPerks: '[data-loyalty-next-perks]',
  loyaltyProgress: '[data-loyalty-progress]',
  loyaltyEarnPoints: '[data-loyalty-earn-points]',
  loyaltyRedeemPoints: '[data-loyalty-redeem-points]',
  loyaltySwitchTier: '[data-loyalty-switch-tiers]',
  loyaltyContainer: '[data-loyalty-container]',
  loyaltyOfferCode: '[data-loyalty-offer-code]',
  loyaltyOfferDescription: '[data-loyalty-offer-description]',
  loyaltyOfferInstruction: '[data-loyalty-offer-instruction]',
  loyaltyOfferCopy: '[data-loyalty-copy]',
  customerProfile: '[data-customer-profile]',
  customerSettings: '[data-customer-settings]',
  customerProfileEdit: '[data-customer-profile-edit]',
  customerSettingsEdit: '[data-customer-settings-edit]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

class CustomerLoyalty {
  constructor(settings = { loyaltyData: [] }) {
    this.loyaltyData = settings.loyaltyData;
    this._loadLoyaltyDetails();
    this._loadLoyaltyOffers(settings.customerName);
    this._setupEventListeners();
  }

  _loadLoyaltyDetails() {
    const parent = this;

    $(`${selectors.loyaltyContainer} .row.load-more_wrap`).show();
    $(`${selectors.loyaltyContainer} .row:not(.load-more_wrap)`).hide();

    if (this.loyaltyData.length == 0) {
      return;
    }

    if ( $(selectors.loyaltyCurrentLevel).length == 0) {
      return;
    }

    $(document).on("swell:setup", function() {
      var customerDetails = swellAPI.getCustomerDetails();

      $(selectors.loyaltyCurrentPoints).html(customerDetails.pointsBalance);
      $(selectors.loyaltyProgress).html(`<div style="max-width: ${ customerDetails.pointsBalance * 0.1 }%;"><span></span></div`);

      let currentLevel = null;
      let nextLevel = null;
      if (customerDetails.vipTier) {
        let currentLevelIndex = parent.loyaltyData.findIndex(loyalty => {
          return loyalty.level.toLowerCase() == customerDetails.vipTier.name.toLowerCase();
        });
        if (currentLevelIndex > -1) {
          currentLevel = parent.loyaltyData[currentLevelIndex];
          nextLevel = currentLevelIndex < parent.loyaltyData.length ? parent.loyaltyData[currentLevelIndex + 1] : {}
        }
      }

      if (currentLevel) {
        $(selectors.loyaltyCurrentLevel).html(currentLevel.level);
        $(selectors.loyaltyCurrentPerks).html(currentLevel.short_description);
        $(selectors.loyaltyEarnPoints).html(currentLevel.earn_points);
        $(selectors.loyaltyRedeemPoints).html(currentLevel.redeem_points);
        $(selectors.loyaltySwitchTier).html(currentLevel.switch_tier);
      }

      if (nextLevel) {
        $(selectors.loyaltyNextLevel).html(nextLevel.level);
        $(selectors.loyaltyNextPerks).html(currentLevel.next_level_description);
      }

      $(`${selectors.loyaltyContainer} .row.load-more_wrap`).hide();
      $(`${selectors.loyaltyContainer} .row:not(.load-more_wrap)`).show();
    })
  }

  _loadLoyaltyOffers(customerName) {
    const parent = this;

    $(`${selectors.loyaltyContainer} .row`).hide();
    $(`${selectors.loyaltyContainer} .row.load-more_wrap`).show();

    if ($(selectors.loyaltyOfferCode).length == 0) {
      return;
    }

    $(document).on("swell:setup", function() {
      const customerRedemoptions = swellAPI.getAllCustomerRedemptions() || [];
      const customerRedemoption = customerRedemoptions.sort((a, b) => (new Date(b.approved_at)) - (new Date(a.approved_at))).find(option => option && option.redemption_option.type == 'Coupon' );
      if (customerRedemoption) {
        $(selectors.loyaltyOfferCode).html(customerRedemoption.reward_text);
        let description = $(selectors.loyaltyOfferDescription).html();
        let instruction = $(selectors.loyaltyOfferInstruction).html();
        let map = [{
          key: '{reward_text}',
          value: customerRedemoption.redemption_option.name
        }, 
         {
          key: '{name}',
          value: customerName,
        },         
       {
          key: '{month}',
          value: (new Date()).toLocaleString('default', { month: 'long' })
        }];
        map.forEach(item => {
          instruction = instruction.replace(item.key, item.value);
          description = description.replace(item.key, item.value);
        });
        $(selectors.loyaltyOfferDescription).html(description);
        $(selectors.loyaltyOfferInstruction).html(instruction);
        $(`${selectors.loyaltyContainer} .row`).show();
      }
      $(`${selectors.loyaltyContainer} .row.load-more_wrap`).hide();

    });
  }

  _setupEventListeners() {
    $(selectors.loyaltyOfferCopy).off('click').on('click', (e) => {
      e.preventDefault();
      navigator.clipboard.writeText($(selectors.loyaltyOfferCode).text());
    });
  }
}

class CustomerProfile {
  constructor() {
    this._setupEventListeners();
  }

  _setupEventListeners() {
    $(selectors.customerProfile).show();
    $(selectors.customerProfileEdit).hide();

    $('body').off('click', '[data-customer-profile-back]').on('click', '[data-customer-profile-back]', (e) => {
      e.preventDefault();
      setTimeout(() => {
        window.location.reload();
      }, 1);
    });

    $('.edit-profile-btn').on('click', (e) => {
      e.preventDefault();
      $(selectors.customerProfile).hide();
      $(selectors.customerProfileEdit).show();
    });

    $('.edit-settings-btn').on('click', (e) => {
      e.preventDefault();
      $(selectors.customerSettings).hide();
      $(selectors.customerSettingsEdit).show();
    });
  }
}

